
import React, { Component } from "react";
import {Input} from "@chakra-ui/react";


export default class TextInput extends Component 
{
    constructor(props)
    {
        super(props);

        this.onValueChange = this.onValueChange.bind(this);
    }

    onValueChange(e) 
    {
        this.props.onValueChange(e.target.value);
    }

    render() 
    {
        return(                

                <Input
                autoFocus
                    backgroundColor={"white"}
                    placeholder={this.props.card.attribTitle}
                    name={this.props.card.Id}
                    value={this.props.cardValue}
                    onChange={this.onValueChange}
                />

        )
    }
}







